import { Button } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 0 20px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ConfirmInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  line-height: 22px;
  gap: 4px;

  span {
    font-weight: 700;
  }
`;

export const PortfolioContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #EDEDED;
  border-radius: 4px;
  width: 100%;
`;

export const PortfolioInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  flex: 1;
`;

export const PortfolioName = styled.h3`
  font-size: 14px;
  line-height: 19px;
  font-weight: 700;
  margin: 0;
`;

export const PortfolioInfoText = styled.p`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin: 0;
  color: #858585;
`;

export const NextButton = styled(Button)`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  font-family: ProximaNovaRg;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;
`;
